<script lang="ts" setup>
import { currentPanel, usePanel } from "@/application/composables/panel";
import { useDisplay } from "vuetify";

const { closePanel } = usePanel();
const { xs: isFullScreen, width: viewportWidth } = useDisplay();

const onUpdate = (value: boolean) => {
  if (!value) closePanel();
};
</script>

<template>
  <VNavigationDrawer
    :model-value="!!currentPanel && !currentPanel.config.closing"
    location="end"
    temporary
    :width="isFullScreen ? viewportWidth : 420"
    class="main-panel"
    :class="{ 'main-panel--rounded': !isFullScreen }"
    @update:model-value="onUpdate"
  >
    <template v-if="currentPanel">
      <div class="d-flex justify-space-between align-start pa-6 pb-4">
        <div>
          <h4
            v-if="currentPanel.config.title"
            class="text-heading text-accent text-truncate"
          >
            {{ currentPanel.config.title }}
          </h4>
          <p
            v-if="currentPanel.config.subtitle"
            class="text-body-2 text-emphasis mt-1"
          >
            {{ currentPanel.config.subtitle }}
          </p>
        </div>

        <VBtn :size="32" icon="$close" variant="plain" @click="closePanel()">
          <VIcon size="24" />
        </VBtn>
      </div>

      <div class="px-6 pb-6">
        <component
          :is="currentPanel.component"
          v-bind="currentPanel.props"
          @close="closePanel()"
        />
      </div>
    </template>
  </VNavigationDrawer>
</template>

<style scoped lang="scss">
.main-panel--rounded {
  border-top-left-radius: 16px !important;
  border-bottom-left-radius: 16px !important;
}
</style>
